import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { titleize } from 'utils';
import { conjunct } from '../../../utils/strings'
import { PaymentProfileType } from '../../../propTypes';
import { billingConfigs, paymentProfiles as paymentProfilesDuck, users, customers } from '../../../ducks/index';
import {
  duckify,
  filterDuck,
  dependentDuck,
  singleDuck
} from '../../../utils/duckify';
import FontAwesome from '../../../utils/FA';
import FALabel from '../../shared/FALabel';
import './styles/PaymentProfileSummary.scss';
import { BILLING_PAYMENT_METHODS } from '../../payments/paymentInputs/PaymentSelector';

class PaymentProfileSummary extends React.Component {
  static propTypes = {
    allDucksReady: PropTypes.bool,
    billingConfig: PropTypes.shape({ disable_autopay: PropTypes.bool }),
    duckMeta: PropTypes.shape({ paymentProfiles: PropTypes.object }),
    paymentProfiles: PropTypes.arrayOf(PaymentProfileType).isRequired
  };

  static defaultProps = {
    allDucksReady: false,
    billingConfig: {},
    duckMeta: { paymentProfiles: {} }
  };

  renderProfiles () {
    const { paymentProfiles } = this.props

    return (
      <div className='payment-profile-summary'>
        <div className='payment-profile-details'>
          <table className='table'>
            <thead>
              <tr>
                <th colSpan={3}>Saved Payment Information</th>
              </tr>
            </thead>
            <tbody>
              {paymentProfiles.map(paymentProfile => {
                const { payment_verification: paymentVerification } = paymentProfile;
                const needsVerification = paymentVerification && paymentVerification.status !== 'verified';
                return (
                  <tr key={paymentProfile.id} className='payment-profile'>
                    <td title={titleize(paymentProfile.payment_method)}>
                      {paymentProfile.payment_method === 'credit card' && <FontAwesome name='credit-card' />}
                      {paymentProfile.payment_method === 'electronic check' && <FontAwesome name='bank' />}
                    </td>
                    <td>
                      {paymentProfile.test_mode && <span className={'badge bg-secondary'}>Test</span>}
                      {' '}
                      {paymentProfile.name}
                    </td>
                    <td>
                      {needsVerification && (
                        <span className='text-warning'>
                          <FALabel icon='exclamation-circle' label=' Verify' iconFirst />
                        </span>
                      )}
                      {!needsVerification && paymentProfile.autopay_enabled && (
                        <span className='autopay-notice'>Automatic Payments Enabled</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <button className='btn btn-primary' type="reset" onClick={(e) => { e.preventDefault(); location.href='/portal/billing/payment_profile' }}>
          Update Payment Details
        </button>
      </div>
    );
  }

  renderSignup () {
    const { customer } = this.props
    const tempMethods = customer.deposit_payment_methods.filter(method => BILLING_PAYMENT_METHODS.includes(method))
    const displayNames = tempMethods.map(method_name => customer.payment_config.payment_methods[method_name].display_name)
    const payments = conjunct(displayNames, 'or')
    const accountInfoHeader = `Save time and avoid late fees by enrolling in AutoPay!`
    const accountInfoPayment = `We'll deduct each payment automatically from your ${payments}.`

    return <div className={'payment-profile-summary payment-profile-signup'}>
      <h4>{accountInfoHeader}</h4>
      <p>{accountInfoPayment}</p>
      <button className='btn btn-primary' type="reset" onClick={(e) => { e.preventDefault(); location.href='/portal/billing/payment_profile'}}>
        Enroll in AutoPay
      </button>

    </div>;
  }

  render () {
    const {
      allDucksReady,
      billingConfig,
      duckMeta: { paymentProfiles: { error } },
      paymentProfiles,
      customer
    } = this.props;

    // No Placeholder; makes UI look too busy
    if (!allDucksReady) {
      return <div />;
    }

    return (customer.allow_online_payments && (!billingConfig.disable_autopay || (paymentProfiles.length > 0))) && (
      <React.Fragment>
        <h2>
          <FontAwesome name='credit-card' nbsp />
          Account Information
        </h2>

        {
          (!error && paymentProfiles.length > 0) && this.renderProfiles()
        }
        {
          (!error && !paymentProfiles.some(x => x.autopay_enabled) && !billingConfig.disable_autopay) && this.renderSignup()
        }
      </React.Fragment>
    );
  }
}

const mapDucksToProps = () => {
  const user = singleDuck(users, 'current');
  const billingConfig = singleDuck(billingConfigs, 'current');

  return {
    billingConfig,
    paymentProfiles: dependentDuck(user, ({ value: currentUser }) => (
      filterDuck(paymentProfilesDuck, { user_id: currentUser.id })
    )),
    user,
    customer: singleDuck(customers, 'current')
  };
};

const mapStateToProps = () => ({});
const mapDispatchToProps = () => ({});

export default duckify(mapDucksToProps, mapStateToProps, mapDispatchToProps)(PaymentProfileSummary);
